import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { UpdateImageAppModel } from '../../../../model/builk/image-app/update-image-app.model';
import { ImageAppService } from '../../../../service/api/builk/image-app.service';

@Component({
  selector: 'app-image-app-detail',
  templateUrl: './image-app-detail.component.html',
  styleUrls: ['./image-app-detail.component.css']
})
export class ImageAppDetailComponent implements OnInit {

  @ViewChild("template") template: TemplateRef<any>;
  modalRef: BsModalRef;
  files: FileList;
  name: string = "";
  link: string = "";
  isUploadFile: boolean = false;
  imageAppSurrKey = 0;
  imageSrc;
  @Output() okEvent = new EventEmitter();
  model: UpdateImageAppModel = new UpdateImageAppModel();
  constructor(
    private modalService: BsModalService,
    private readonly imageAppService: ImageAppService
  ) { }
  ngOnInit() {
  }

  openModal(name: string, link: string, imageAppSurrKey: number, imageUrl: string): void {
    this.name = name;
    this.link = link;
    this.imageAppSurrKey = imageAppSurrKey;
    this.imageSrc = imageUrl;

    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
  }

  save () {
    //save
    if (this.isUploadFile) {
      this.model.file = this.files[0];
    }
    this.model.title = this.name;
    this.model.linkUrl = this.link;
    this.model.isUploadFile = this.isUploadFile;
    this.model.imageAppSurrKey = this.imageAppSurrKey;
    
    this.imageAppService.updateImage(this.model).subscribe(res => {
      this.okEvent.emit(true);
      this.modalRef.hide();
    }, (err) => {

    });
  }
  cancel () {
    this.modalRef.hide();
  }

  getImage() {
    if(this.files.length > 0) {
      const file = this.files[0];
      this.isUploadFile = true;
      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }
  uploadFile(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      this.files = fileList;
      this.getImage();
    }
  }
}
